import axios from 'axios'
import { getToken, clearAuth } from './auth'
import store from '@/store' // 导入store

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'

  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 获取access_token并添加到请求头
    const token = getToken()
    if (token) {
      //config.headers.Authorization = `${token}`
      config.headers['access-token'] = token
    }
    // 自动添加language参数
    const language = store.getters.language
    config.params = config.params || {}
    config.params.lang = language
    //config.params.access_token = token
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    if (res.code && res.code !== 0) {
      console.log('接口错误:', res.message)
      //return Promise.reject(new Error(res.message || 'Error'))
    }
    return res
  },
  error => {
    console.error('响应错误:', error)
    
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // token过期或无效，清除认证信息
          clearAuth()
          store.commit('setLoginStatus', false); // 更新登录状态

          // 可以在这里触发路由跳转
          // window.location.href = '/login'
          break
        case 403:
          console.error('没有权限访问')
          break
        case 404:
          console.error('请求的资源不存在')
          break
        case 500:
          console.error('服务器内部错误')
          break
        default:
          console.error('网络错误')
      }
    }
    
    return Promise.reject(error)
  }
)

// 为service实例添加便捷方法
service.get = (url, params = {}) => {
  return service({
    method: 'get',
    url,
    params
  })
}

service.post = (url, data = {}) => {
  return service({
    method: 'post',
    url,
    data
  })
}

export default service